// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__23lUT","text":"SelectPayment_text__2O48c","title":"SelectPayment_title__3LgYe","btn":"SelectPayment_btn__1Uslc"};